import { RESET_PASSWORD_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

import resetPasswordSchema from 'root/src/shared/descriptions/formSchemas/resetPasswordSchema'

export default {
	[RESET_PASSWORD_FORM_MODULE_ID]: {
		moduleType: 'form',
		schema: resetPasswordSchema,
		title: 'Verify and Create new Password',
		fields: [
			{
				fieldId: 'password',
				label: 'Password',
				inputType: 'password',
			},
			{
				fieldId: 'confirmPassword',
				label: 'Confirm password',
				inputType: 'password',
			},
		],
		submits: [
			{ label: 'Create new Password' },
		],
	},
}
